module.exports = __webpack_public_path__ + "media/tul.61a9f13c.wav";